var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTabletSlim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.789062 10.6836C0.789062 11.5381 1.36523 12.0947 2.24902 12.0947H7.74219C8.62598 12.0947 9.20215 11.5381 9.20215 10.6836V2.26562C9.20215 1.40625 8.62598 0.849609 7.74219 0.849609H2.24902C1.36523 0.849609 0.789062 1.40625 0.789062 2.26562V10.6836ZM1.76074 10.5225V2.42188C1.76074 2.04102 1.98535 1.82617 2.38574 1.82617H7.60547C8.00586 1.82617 8.23047 2.04102 8.23047 2.42188V10.5225C8.23047 10.9033 8.00586 11.123 7.60547 11.123H2.38574C1.98535 11.123 1.76074 10.9033 1.76074 10.5225ZM3.5625 10.7129H6.43359C6.58008 10.7129 6.68262 10.6152 6.68262 10.4688C6.68262 10.3174 6.58008 10.2197 6.43359 10.2197H3.5625C3.4209 10.2197 3.31348 10.3174 3.31348 10.4688C3.31348 10.6152 3.4209 10.7129 3.5625 10.7129Z",
    fill: "#89898E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTabletSlim);
export default __webpack_public_path__ + "static/media/icon-tablet-slim.7cc2d9695d92ce7e8fec6ccc312c580e.svg";
export { ForwardRef as ReactComponent };